import { useQuery, useQueryClient } from 'react-query';

import { documentApi } from '../api/document';

const GET_NEXT_AVAILABLE_DOCUMENT_CODE_KEY =
  'GET_NEXT_AVAILABLE_DOCUMENT_CODE_KEY';

export const nextAvailableDocumentCodeQueryKey = (
  companyId: number,
  templateId: number | null,
) => [GET_NEXT_AVAILABLE_DOCUMENT_CODE_KEY, companyId, templateId];

export const useInvalidateNextAvailableDocumentCode = (
  companyId: number,
  templateId: number | null,
) => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries(
      nextAvailableDocumentCodeQueryKey(companyId, templateId),
    );
};

export const useNextAvailableDocumentCode = (
  companyId: number,
  templateId: number | null,
  enabled: boolean,
) => {
  return useQuery<string>({
    queryKey: nextAvailableDocumentCodeQueryKey(companyId, templateId),
    queryFn: () =>
      documentApi.fetchNextAvailableDocumentCode(
        companyId,
        templateId as number,
      ),
    enabled: enabled && Boolean(templateId),
    refetchOnWindowFocus: false,
  });
};
